<template>
  <div class="oauth-credentials">
    <FormSection
      :title="$t('APP.OAUTH.TITLE')"
      :description="$t('APP.OAUTH.GUIDE_MESSAGE')"
    >
      <Card :is-loading="oAuthLoading">
        <div>
          <h4 class="oauth-credentials__property">
            {{ $t('APP.OAUTH.CLIENT_ID') }}:
          </h4>

          <CodeBlock :content="clientId" style="margin-bottom: 1rem" />
        </div>
        <div>
          <h4 class="oauth-credentials__property">
            {{ $t('APP.OAUTH.SECRET') }}:
            <ElButton
              v-if="secretIsHidden"
              type="primary"
              size="small"
              class="oauth-credentials__show-secret"
              @click="showSecret"
            >
              {{ $t('APP.OAUTH.SHOW_SECRET') }}
            </ElButton>
          </h4>
          <div v-if="!secretIsHidden">
            <CodeBlock :content="clientSecret" style="margin-bottom: 1rem" />
          </div>
        </div>
      </Card>
    </FormSection>
  </div>
</template>

<script>
import { OAuth } from '@/api/api';
import FormSection from '@@/common/layout/FormSection';
import Card from '@@/common/Card';
import CodeBlock from '@@/common/CodeBlock';
import packageNameWatch from '@/mixins/apps/packageNameWatch';
import packageName from '@/mixins/packageName';

import selection from '@/directives/selection';

export default {
  name: 'OAuthCredentials',

  directives: {
    selection,
  },

  components: {
    FormSection,
    Card,
    CodeBlock,
  },

  mixins: [packageName, packageNameWatch],

  data() {
    return {
      oAuthLoading: true,
      secretIsHidden: true,
      clientId: '',
      clientSecret: '',
    };
  },

  created() {
    this.getInfo();
  },

  methods: {
    showSecret() {
      this.secretIsHidden = false;
    },
    getInfo() {
      this.oAuthLoading = true;

      return OAuth.getClients({
        packageName: this.packageName,
      })
        .then(clients => {
          const { clientId, clientSecret } = clients[0];
          this.clientId = clientId;
          this.clientSecret = clientSecret;
          this.secretIsHidden = true;
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.oAuthLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.oauth-credentials {
  &__property {
    direction: ltr;
  }

  &__show-secret {
    text-align: center;
  }
}
</style>
